import type { IconSvgObject } from './types';

const SquareLockCheck01Icon: IconSvgObject = [
  ["path", { d: "M15 9V6.5C15 4.01472 12.9853 2 10.5 2C8.01472 2 6 4.01472 6 6.5V9M18.5 14V11C18.5 9.89543 17.6046 9 16.5 9H4.50019C3.39554 9 2.50008 9.89554 2.50018 11.0002L2.50102 20.0002C2.50112 21.1047 3.39652 22 4.50102 22H11", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14 19.5L16.5 22L21.5 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default SquareLockCheck01Icon;
